export {
    startTabSession,
    isTabSession,
    getAuthToken,
    setAuthToken,
    allowReturnToParent,
    canReturnToParent,
    returnToParent,
    showTabLogin,
}

const KEY = process.env.VUE_APP_PRODUCT + '.authtoken'
const RETURN_KEY = KEY + '.return'

function startTabSession() {
    sessionStorage.setItem(KEY, '')
}

function isTabSession() {
    return sessionStorage.getItem(KEY) !== null
}

function storage() {
    return isTabSession() ? sessionStorage : localStorage
}

function getAuthToken() {
    return storage().getItem(KEY)
}

function setAuthToken(token) {
    storage().setItem(KEY, token)
}

function allowReturnToParent() {
    sessionStorage.setItem(RETURN_KEY, '1')
}

function canReturnToParent() {
    return sessionStorage.getItem(RETURN_KEY) !== null
}

function returnToParent() {
    sessionStorage.removeItem(KEY)
    sessionStorage.removeItem(RETURN_KEY)
    window.location.assign('/')
}

// The empty token keeps the tab marked, so neither F5 nor this login page can silently pick up the parent's token
function showTabLogin() {
    sessionStorage.setItem(KEY, '')
    sessionStorage.removeItem(RETURN_KEY)
    window.location.assign('/login')
}
